var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgicon = function SvgSvgicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.296 4.8a.8.8 0 0 1-.8.8h-.8v4.8h.8a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h-4.8v.8a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-3.2a.8.8 0 0 1 .8-.8h.8V5.6h-.8a.8.8 0 0 1-.8-.8V1.6a.8.8 0 0 1 .8-.8h3.2a.8.8 0 0 1 .8.8v.8h4.8v-.8a.8.8 0 0 1 .8-.8h3.2a.8.8 0 0 1 .8.8v3.2Zm-1.6-2.4h-1.6V4h1.6V2.4Zm-11.2 0h1.6V4h-1.6V2.4Zm0 11.2h1.6V12h-1.6v1.6Zm11.2 0h-1.6V12h1.6v1.6Zm-2.4-3.2h.8V5.6h-.8a.8.8 0 0 1-.8-.8V4h-4.8v.8a.8.8 0 0 1-.8.8h-.8v4.8h.8a.8.8 0 0 1 .8.8v.8h4.8v-.8a.8.8 0 0 1 .8-.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgSvgicon;